export default {"src":"/_next/static/media/black-square-meters.a9a4801d.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};